// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3543":"9cd26a487baa5168","4351":"d6a5423331188fe4"}[chunkId] + ".js";
};